<template>
  <div class="a11y-modal">
    <div class="title">
      <h2>A message from BetterMynd</h2>
    </div>

    <div class="body">
      <p>
        We are currently experiencing issues with SMS text notifications. Please check your email for session and workshop reminders.
        <br><br>
        This message will be updated when the issue is resolved.
        <br><br>
        We apologize the inconvenience!
      </p>
    </div>

    <div class="actions">
      <button type="button" @click="$modal.close()">Ok</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmsCommunicationOutageModal',

};
</script>

<style lang="scss" scoped>
.a11y-modal div.title {
  padding: 10px 20px 10px 20px;
  border-bottom: 0px
}
div.body {
  margin: 0 24px 0 24px;
}
p {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 14px;
}
</style>
